import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {connect} from 'react-redux';
import {Grid, Segment, Header, Dimmer, Loader} from 'semantic-ui-react';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {canViewPanelChairReview, canViewPanelReviews} from 'go/security/permissions';
import PendingPanelChairReviewList from 'go/components/panelReview2/pendingPanelChairReviewList';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {PANEL_REVIEWER_TASKS} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';

export class PanelReviewDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      extraAttribute: '',
      pendingReview: [],
      pendingDiscussion: [],
      panelReReview: [],
      loading: true,
      discussionEnabled: true,
    };
  }

  componentDidMount() {
    document.title = PANEL_REVIEWER_TASKS;
    if (canViewPanelReviews(this.props.permissions)) {
      const panelSessionId = this.props.match.params.sessionId;
      REST.panelReviewV2
        .getPanelSessionInfo(this.props.jwt, panelSessionId)
        .then(REST.handler.handleResponse)
        .then((res) => {
          // check here what the naming for the path of Config
          const discussionEnabled = _.get(res, 'discussionEnabled', true);
          this.setState({discussionEnabled});

          this.fetchSessionConfig(panelSessionId, 'aliases').then((config) => {
            this.setHeadersInState(config);
            //set the config to state
          });

          let getWorkflowPanelReview = {};
          getWorkflowPanelReview.assignee = this.props.userId;

          let taskdefs = {
            pendingReview: 'panelReviewMultiTask',
            pendingDiscussion: 'tableDiscussion',
            panelReReview: 'panelRe-Review',
          };
          _.forEach(taskdefs, (taskName, pendingName) => {
            _.assign(getWorkflowPanelReview, {
              assignee: this.props.userId,
              processDefinitionKey: 'panelReview',
              taskDefinitionKey: taskName,
              processVariables: [
                {
                  name: 'sessionId',
                  value: _.parseInt(panelSessionId),
                  operator: 'eq',
                },
              ],
            });
            return REST.workflow
              .getAllExternalEligibleTasks(
                this.props.token,
                ['sessionId', 'grantId', 'entityDisplay', 'organizationName', 'category'],
                getWorkflowPanelReview
              )
              .then(REST.handler.handleResponse)
              .then((responseJson) => {
                this.setState({
                  [pendingName]: responseJson,
                  loading: false,
                });
                return responseJson;
              })
              .catch(console.error('error. data not found.'));
          });
        });
    } else {
      this.setState({loading: false});
    }
  }

  fetchSessionConfig = (panelSessionId, taskDefKey) => {
    const {token} = this.props;
    return REST.panelReviewV2
      .getPanelSessionConfiguration(token, panelSessionId, taskDefKey)
      .then(REST.handler.handleResponse);
  };

  setHeadersInState(config) {
    _.map(config, (aliases) => {
      _.map(aliases, (alias) => {
        this.setState({
          [_.get(alias, 'value')]: _.get(alias, 'label'),
        });
      });
    });
  }

  renderButton(task) {
    switch (task.taskDefinitionKey) {
      case 'panelReviewMultiTask':
        return (
          <a
            href={`/panelReview/sessions/${this.props.match.params.sessionId}/tasks/${task.id}`}
            aria-label={`Start Review ${task['entityDisplay']}`}
          >
            Start Review >
          </a>
        );
      case 'tableDiscussion':
        return (
          <a
            href={`/panelReview/sessions/${this.props.match.params.sessionId}/tasks/${task.id}`}
            aria-label={`Join Discussion ${task['entityDisplay']}`}
          >
            {' '}
            Join Discussion >
          </a>
        );
      case 'panelRe-Review':
        return (
          <a
            href={`/panelReview/sessions/${this.props.match.params.sessionId}/tasks/${task.id}`}
            aria-label={`Start ReReview ${task['entityDisplay']}`}
          >
            Start ReReview >
          </a>
        );
    }
  }

  renderTable(tasks) {
    if (tasks && tasks.length) {
      return tasks.map((task, index) => {
        return (
          <FemaGoTable.Row key={`${task['entityId']}${index}`}>
            <FemaGoTable.TextCell id={index}>
              {task['organizationName']}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell id={index}>
              {task['entityDisplay']}
            </FemaGoTable.TextCell>
            <FemaGoTable.TextCell id={index}>{task['category']}</FemaGoTable.TextCell>
            <FemaGoTable.TextCell id={index}>
              {this.renderButton(task)}
            </FemaGoTable.TextCell>
          </FemaGoTable.Row>
        );
      });
    } else {
      return (
        <FemaGoTable.Row>
          <FemaGoTable.TextCell>
            There are currently no applications in the queue.
          </FemaGoTable.TextCell>
        </FemaGoTable.Row>
      );
    }
  }

  render() {
    const {pendingReview, pendingDiscussion, panelReReview, loading} = this.state;
    if (!loading) {
      return (
        <React.Fragment>
          <Grid>
            <Grid.Column>
              <Main>
                {canViewPanelChairReview(this.props.permissions) && (
                  <PendingPanelChairReviewList
                    panelSessionId={this.props.match.params.sessionId}
                  />
                )}
                {canViewPanelReviews(this.props.permissions) && (
                  <div>
                    <Header as="h3">Actions Needed</Header>
                    <Segment padded className="panel-review-dashboard">
                      <Header as="h4">Your next review</Header>
                      <FemaGoTable type="static" summary="Your next review">
                        <FemaGoTable.Header>
                          <FemaGoTable.Row>
                            <FemaGoTable.HeaderCell>
                              {_.get(this.state, 'organization', 'Applicant')}
                            </FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>
                              {_.get(this.state, 'id', 'Application ID')}
                            </FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>
                              {_.get(this.state, 'category', 'Application Category Type')}
                            </FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
                          </FemaGoTable.Row>
                        </FemaGoTable.Header>
                        <FemaGoTable.Body>
                          {this.renderTable(pendingReview)}
                        </FemaGoTable.Body>
                      </FemaGoTable>
                    </Segment>
                    {this.state.discussionEnabled && (
                      <Segment padded className="panel-review-dashboard">
                        <Header as="h4">Applications Pending Discussion</Header>
                        <FemaGoTable
                          type="static"
                          summary="Applications Pending Discussion"
                        >
                          <FemaGoTable.Header>
                            <FemaGoTable.Row>
                              <FemaGoTable.HeaderCell>
                                {_.get(this.state, 'organization', 'Applicant')}
                              </FemaGoTable.HeaderCell>
                              <FemaGoTable.HeaderCell>
                                {_.get(this.state, 'id', 'Application ID')}
                              </FemaGoTable.HeaderCell>
                              <FemaGoTable.HeaderCell>
                                {_.get(
                                  this.state,
                                  'category',
                                  'Application Category Type'
                                )}
                              </FemaGoTable.HeaderCell>
                              <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
                            </FemaGoTable.Row>
                          </FemaGoTable.Header>
                          <FemaGoTable.Body>
                            {this.renderTable(pendingDiscussion)}
                          </FemaGoTable.Body>
                        </FemaGoTable>
                      </Segment>
                    )}
                    <Header as="h3">Panel Re-Review</Header>
                    <Segment padded className="panel-review-dashboard">
                      <FemaGoTable type="static" summary="Panel Re-Review table">
                        <FemaGoTable.Header>
                          <FemaGoTable.Row>
                            <FemaGoTable.HeaderCell>
                              {_.get(this.state, 'organization', 'Applicant')}
                            </FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>
                              {_.get(this.state, 'id', 'Application ID')}
                            </FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>
                              {_.get(this.state, 'category', 'Application Category Type')}
                            </FemaGoTable.HeaderCell>
                            <FemaGoTable.HeaderCell>Action</FemaGoTable.HeaderCell>
                          </FemaGoTable.Row>
                        </FemaGoTable.Header>
                        <FemaGoTable.Body>
                          {this.renderTable(panelReReview)}
                        </FemaGoTable.Body>
                      </FemaGoTable>
                    </Segment>
                  </div>
                )}
              </Main>
            </Grid.Column>
          </Grid>
        </React.Fragment>
      );
    } else {
      return (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      );
    }
  }
}

export const mapStateToProps = (state) => {
  const returnObject = {
    jwt: state.auth.token,
    permissions: state.auth.permissions,
    userId: state.auth.userId,
    token: state.auth.token,
  };

  return returnObject;
};

export default connect(mapStateToProps)(connectDynamic(PanelReviewDashboard));
